export const history = {
  history: 'Historique',
  deleted: 'Supprimée',
  modified: 'Modifiée',
  added: 'Ajoutée',
};
